<div
  class="img-list"
  [ngStyle]="{ 'grid-template-columns': 'repeat(' + perRow() + ', 1fr)' }"
>
  @for (image of processedImageArray(); track $index) {
    <app-img-gallery-item
      class="my-2 img-item"
      [image]="image"
      [galleryId]="'project-gallery'"
      (loaded)="reInitLightbox()"
    />
  }
  @if (remainingImgCount()! > 0) {
    <div class="more-img my-2" (click)="showAll()">
      <span class="fas fa-plus more-img-icon"></span>
      <span class="remaining-count">
        {{ remainingImgCount() }}
      </span>
    </div>
  }
</div>
